import React from 'react';
import { listUserFormTabErrors } from '../utils/userFormTabErrors';
import './UserFormTabErrorBanner.css';

export function UserFormTabErrorBanner({ errors, onGoToTab }) {
  const items = listUserFormTabErrors(errors);
  if (!items.length) return null;

  return (
    <div className="user-form-tab-error-banner" role="alert">
      <p className="user-form-tab-error-banner-title">Corrija os erros abaixo para salvar</p>
      <ul className="user-form-tab-error-banner-list">
        {items.map((item) => (
          <li key={item.key}>
            <button
              type="button"
              className="user-form-tab-error-banner-link"
              onClick={() => onGoToTab?.(item.tab)}
            >
              <span className="user-form-tab-error-banner-where">{item.tabLabel}</span>
              <span className="user-form-tab-error-banner-sep" aria-hidden>
                ·
              </span>
              <span className="user-form-tab-error-banner-field">{item.fieldLabel}</span>
              <span className="user-form-tab-error-banner-msg">{item.message}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
